import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";

import { Col, Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import { getCurrencySymbol } from "@/utils";

interface IPaymentCardHeaderProps {
  currency: string;
  orderTotal: string;
}

export const PaymentCardHeader = ({ currency, orderTotal }: IPaymentCardHeaderProps) => {
  return (
    <Row className="w-full bg-gray-50 px-6 py-5 rounded-xl items-center" style={undefined}>
      <Col gap={0.5}>
        <Text variant={"lg"} type={"font-[600]"}>
          {getCurrencySymbol(currency)}
          {orderTotal}
        </Text>
        <Text>
          <Trans i18nKey="subscription:checkoutSuccess.paymentSuccessful" />
        </Text>
      </Col>
      <Row>
        <Icon icon={IconVariants.CHECK} size={IconSize.XLARGE} className="bg-blue-600 rounded-full p-1 shadow-[0_0_0px_10px_#0072F570]" />
      </Row>
    </Row>
  );
};
